/**
 * Komunikat promocyjny „dołącz za darmo".
 *
 * ═══ WSZYSTKO W JEDNYM MIEJSCU, BO TO ZNIKNIE ═══
 * To treść czasowa — promocja skończy się szybciej niż kod, który ją wyświetla.
 * Rozsypana po trzech komponentach zostawiłaby po sobie plakietkę w nawigacji
 * jeszcze długo po tym, jak przestanie być prawdziwa.
 *
 * WYŁĄCZENIE: `PROMOCJA_AKTYWNA = false` i znika wszędzie naraz — plakietka przy
 * przycisku w pasku oraz adnotacje na kafelkach wyboru. Nic więcej nie trzeba ruszać.
 */

export const PROMOCJA_AKTYWNA = true

/** Plakietka wystająca nad przyciskiem „Zostań partnerem" w pasku nawigacji. */
export const PLAKIETKA_CTA = '2 minuty · za darmo'

/** Adnotacja na kafelkach wyboru (wykonawca / dystrybutor). */
export const ADNOTACJA_KAFELKA = 'Przez ograniczony czas dołączenie jest bezpłatne'

export default PROMOCJA_AKTYWNA
